import React from 'react';
import MinusIconSvg from './Minus.svg';

const MinusIcon = (props) => (
    /* TODO - change to 'webpack inlined' when on react-scripts 2.0 - https://facebook.github.io/create-react-app/docs/adding-images-fonts-and-files#adding-svgs */
    <img src={MinusIconSvg} alt="Collapse" {...props} />
);

export default MinusIcon;
